'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateForm = exports.validateField = exports.resetForm = exports.populateForm = exports.resetFields = exports.setValues = exports.setValue = undefined;
var _updateFields = require('./update-fields');
var _updateForm = require('./update-form');
var _validation = require('./validation');
exports.setValue = _updateFields.setValue;
exports.setValues = _updateFields.setValues;
exports.resetFields = _updateFields.resetFields;
exports.populateForm = _updateForm.populateForm;
exports.resetForm = _updateForm.resetForm;
exports.validateField = _validation.validateField;
exports.validateForm = _validation.validateForm;